import { boolean, object, string } from 'yup';

export const validationSchema = object().shape({
  bundleId: string().required(),
  description: string()
    .max(240, 'Description must be max 240 characters')
    .required('Description is required'),
  softwareCompany: string()
    .optional()
    .max(32, 'Software Company must be max 32 characters'),
  hideInvoiceLines: boolean(),
  hideInvoiceValues: boolean(),
});